<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1590"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1594"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1604"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1602" /></clipPath></defs><g
     id="g1596"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1598"><g
         id="g1600"
         clip-path="url(#clipPath1604)"><g
           id="g1606"
           transform="translate(502.002,460.6035)"><path
             d="M 0,0 V 0 C -0.003,0 -127.941,-6.737 -246,-6.737 -364.061,-6.737 -492,0 -492,0 v -328.667 c 0,0 127.939,6.737 246,6.737 118.058,0 245.993,-6.737 246,-6.737 z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1608" /></g><g
           id="g1610"
           transform="translate(211.4375,186.481)"><path
             d="m 0,0 c -44.357,-0.552 -87.679,-1.811 -122.709,-3.07 -46.75,-1.69 -78.73,-3.37 -78.73,-3.37 v -48.11 c 0,0 127.94,6.74 246,6.74 118.059,0 246,-6.73 246,-6.74 v 48.11 c 0,0 -98.62,5.187 -202.587,6.453 V 0.012"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1612" /></g><g
           id="g1614"
           transform="translate(325.918,137.9399)"><path
             d="M 0,0 V -42.03 H -142.65 V 0 c 23.86,0.45 48.5,0.73 72.73,0.73 23.24,0 46.86,-0.26 69.82,-0.68 z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1616" /></g><g
           id="g1618"
           transform="translate(336.0117,95.9136)"><path
             d="m 0,0 h -164.207 c -24.375,0 -46.838,-16.206 -58.692,-37.505 l -3.903,-7.012 H 62.596 l -3.904,7.012 C 46.839,-16.206 24.376,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1620" /></g><g
           id="g1622"
           transform="translate(55.0605,231.3838)"><path
             d="M 0,0 407.787,177.003"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1624" /></g><g
           id="g1626"
           transform="translate(424.6396,421.522)"><path
             d="M 0,0 38.211,-13.105 22.179,-50.603"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1628" /></g><g
           id="g1630"
           transform="translate(93.2715,218.2788)"><path
             d="m 0,0 -38.211,13.104 16.032,37.499"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1632" /></g><g
           id="g1634"
           transform="translate(255.998,186.771)"><path
             d="M 0,0 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1636" /></g></g></g></g></svg>
</template>
